export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const SET_LAST_LOCATION = 'SET_LAST_LOCATION';
export const SET_APP_ELEMENT = 'SET_APP_ELEMENT';
export const SET_GLOBAL_ERROR = 'SET_GLOBAL_ERROR';
export const CLEAR_GLOBAL_ERRORS = 'CLEAR_GLOBAL_ERRORS';
